/**
 * Adds autocomplete functionnality to text input which its container has the class 'autocomplete'.
 * Depends that the Gravity Fields have the corresponding classes.
 * The main container of the fields must have the name parameter as class.
 *
 * @param {string} name the field name which is also the endpoint name.
 */
export function addAutocompleteFields( name ) {

    window.mce = 'mce' in window ? window.mce : {};

    const $phoneInput = $( `.${name} .phone input` );
    const $faxInput = $( `.${name} .fax input` );
    const $address = $( `.${name} .address .address_line_1` );
    const $addressLine2 = $( `.${name} .address .address_line_2` );
    const $city = $( `.${name} .address .address_city` );
    const $state = $( `.${name} .address .address_state` );
    const $zipcode = $( `.${name} .address .address_zip` );
    const $addressInput = $( `.${name} .address .address_line_1 input` );
    const $addressLine2Input = $( `.${name} .address .address_line_2 input` );
    const $cityInput = $( `.${name} .address .address_city input` );
    const $stateInput = $( `.${name} .address .address_state select` );
    const $zipcodeInput = $( `.${name} .address .address_zip input` );
    const addressSelectorClass = 'attorney-addresses-list';
    const newAddressFlag = 'add-new';

    $( '.autocomplete input' ).autocomplete({
        source:function( request, response ) {
            $.ajax({
                url:`${window.mce.api_url}${name}`,
                type:'get',
                data:{
                    input:request.term,
                },
                success:function( data ) {
                    response( data );
                }
            });
        },
        minLength:2,
        select:function( event, ui ) {
            const object = ui.item;

            if ( Object.prototype.hasOwnProperty.call( object, 'id' ) ) {
                $.ajax({
                    url:`${window.mce.api_url}person/addresses`,
                    type:'get',
                    data:{ id:object.id },
                    success:function( data ) {
                        if ( $( `.${addressSelectorClass}` ).length ) {
                            $( `.${addressSelectorClass}` ).parent( 'li' ).remove();
                        }

                        showAddressFields();

                        if ( data.length > 0 ) {
                            hideAddressFields();
                            displayAddressList( data );
                        }
                    }
                });
            }

            $phoneInput.val( ui.item.phone );
            $faxInput.val( ui.item.fax );
            $addressInput.val( ui.item.address );
            $addressLine2Input.val( ui.item.address_line_2 );
            $cityInput.val( ui.item.city );
            $stateInput.val( ui.item.state );
            $zipcodeInput.val( ui.item.zipcode );
        }
    });

    /**
     * Hides Doctor Address and Zip Code td elements.
     */
    function hideAddressFields() {
        $address.hide();
        $addressLine2.hide();
        $city.hide();
        $state.hide();
        $zipcode.hide();
    }

    /**
     * Shows Doctor Address and Zip Code td elements.
     */
    function showAddressFields() {
        $address.show();
        $addressLine2.show();
        $city.show();
        $state.show();
        $zipcode.show();
    }

    /**
     * Initializes and display attorneys's addresses drop-down
     * @param {array} data A JSON data object.
     */
    function displayAddressList( data ) {
        const list = $( '<select />' ).addClass( `gform_multi_address ${addressSelectorClass}` );
        const li = $( '<li data-label="Available addresses">' ).addClass( 'gfield' );

        for ( const index in data ) {
            const address = data[ index ][ 'Address' ];
            const addressLine2 = data[ index ][ 'Address Line 2' ];
            const city = data[ index ][ 'City' ];
            const state = data[ index ][ 'State' ];
            const zipCode = data[ index ][ 'Zip Code' ];
            const phone = data[ index ][ 'Phone' ];
            const fax = data[ index ][ 'Fax' ];
            const fullAddress = data[ index ][ 'Full Address' ];

            $( '<option />', { value:index, text:fullAddress }).attr({
                'address':address,
                'address-line-2':addressLine2,
                'city':city,
                'state':state,
                'phone':phone,
                'fax':fax,
                'zip-code':zipCode
            })
            .appendTo( list );
        }

        $( '<option />', { value:newAddressFlag, text:'Add new address' })
        .attr({ 'address':'', 'address-line-2':'', 'city':'', 'state':'', 'zip-code':'' })
        .appendTo( list );

        list.on( 'change', function onAddressChange() {
            selectAddress( this );
        }).appendTo( li );

        li.insertBefore( $address.closest( 'li' ) );
    }

    /**
     * Auto-fill address and Zip Code on address change
     *
     * @param {element} element Address select element.
     */
    function selectAddress( element ) {
        $( element ).val() === newAddressFlag ? showAddressFields() : hideAddressFields();
        $addressInput.val( $( element ).find( ':selected' ).attr( 'address' ) );
        $addressLine2Input.val( $( element ).find( ':selected' ).attr( 'address-line-2' ) );
        $cityInput.val( $( element ).find( ':selected' ).attr( 'city' ) );
        $stateInput.val( $( element ).find( ':selected' ).attr( 'state' ) );
        $zipcodeInput.val( $( element ).find( ':selected' ).attr( 'zip-code' ) );

        $phoneInput.val( $( element ).find( ':selected' ).attr( 'phone' ) );
        $faxInput.val( $( element ).find( ':selected' ).attr( 'fax' ) );
    }
}
